import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  name: string;
  shortName?: string;
  href: string;
  icon: string;
}

interface BottomNavProps {
  navigation: NavItem[];
}

export const BottomNav: React.FC<BottomNavProps> = ({ navigation }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/dashboard') return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  const visibleItems = navigation.slice(0, 5);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden print:hidden bg-shell-900"
      style={{
        paddingBottom: 'var(--app-safe-bottom, env(safe-area-inset-bottom, 0px))',
      }}
    >
      <div className="flex justify-around items-center h-16">
        {visibleItems.map((item) => {
          const active = isActive(item.href);
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex flex-col items-center justify-center flex-1 h-full px-1 py-2 text-xs font-medium transition-colors outline-none focus:outline-none focus-visible:outline-none ${
                active ? 'text-white' : 'text-brand-300 hover:text-brand-100'
              }`}
              style={{ WebkitTapHighlightColor: 'transparent' }}
            >
              <svg className="w-5 h-5 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
              </svg>
              <span className="truncate max-w-full px-0.5 leading-none">{item.shortName ?? item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
